document.addEventListener('DOMContentLoaded',function(){
  var handles=['rose-quartz-3d-facial-roller','natural-jade-roller-gua-sha-set'];
  document.querySelectorAll('[data-virelto-product]').forEach(function(s){
    if(handles.indexOf(s.dataset.productHandle||'')===-1)return;
    var q=s.querySelector('[data-product-variant-select]');
    var t=[].slice.call(s.querySelectorAll('[data-gallery-thumb]'));
    var c=s.querySelector('[data-gallery-count]');
    var p=s.querySelector('[data-gallery-prev]');
    var n=s.querySelector('[data-gallery-next]');
    function f(){
      t.forEach(function(x){x.hidden=false});
      if(p)p.hidden=t.length<=1;
      if(n)n.hidden=t.length<=1;
      var o=q&&q.options[q.selectedIndex];
      var id=o&&o.dataset.imageId;
      var a=id&&t.find(function(x){return String(x.dataset.imageId)===String(id)});
      if(a)a.click();
      if(c){
        var i=Math.max(0,t.findIndex(function(x){return x.classList.contains('is-active')}));
        c.textContent=String(i+1)+' / '+String(Math.max(t.length,1));
      }
    }
    if(q)q.addEventListener('change',function(){setTimeout(f,0)});
    setTimeout(f,0);
  });
});